import { isa } from "@p0security/shared/types/is";
import {
  RequestStatus,
  RequestStatuses,
} from "@p0security/shared/types/request-status";
import { Tooltip } from "antd";
import { StyledTag } from "styles/StyledTags";

import { COLOR_MAP } from "../requestUtils";

const STATUS_MAPPING: Record<RequestStatus, keyof typeof COLOR_MAP> = {
  EXPIRED_NOTIFIED: "Expired",
  EXPIRED: "Expired",
  NEW: "Request Created",
  PENDING_APPROVAL: "Pending Approval",
  PENDING_APPROVAL_ESCALATED: "Pending Approval",
  APPROVED: "Approved",
  DENIED: "Denied",
  REVOKED: "Relinquished",
  DONE: "Granted",
  DRAFT: "Not yet created",
  APPROVED_NOTIFIED: "Approved",
  DENIED_NOTIFIED: "Denied",
  ERRORED_NOTIFIED: "Errored",
  DONE_NOTIFIED: "Granted",
  ERRORED_ERRORED: "Errored",
  ERRORED: "Errored",
  EXPIRY_SUBMITTED: "Expiring",
  REVOKE_SUBMITTED: "Relinquishing",
  REVOKED_NOTIFIED: "Relinquished",
  STAGED: "Staged",
  TRANSLATED: "N/A",
  CLEANUP_SUBMITTED: "Expiring",
  CLEANED_UP: "Expired",
  CLEANUP_ERRORED: "Errored",
  TIMED_OUT: "Timed Out",
  TIMED_OUT_NOTIFIED: "Timed Out",
} as const;

const TIMED_OUT_TOOLTIP_MESSAGE =
  "The request wasn't approved in time, and access was not granted.";

const TOOLTIP_MAPPING: Record<RequestStatus, string | undefined> = {
  APPROVED_NOTIFIED: undefined,
  APPROVED: undefined,
  CLEANUP_ERRORED: undefined,
  CLEANUP_SUBMITTED: undefined,
  CLEANED_UP: undefined,
  DENIED_NOTIFIED: undefined,
  DENIED: undefined,
  DONE_NOTIFIED: undefined,
  DONE: undefined,
  DRAFT: undefined,
  ERRORED_ERRORED: undefined,
  ERRORED_NOTIFIED: undefined,
  ERRORED: undefined,
  EXPIRED_NOTIFIED: undefined,
  EXPIRED: undefined,
  EXPIRY_SUBMITTED: undefined,
  NEW: undefined,
  PENDING_APPROVAL: undefined,
  PENDING_APPROVAL_ESCALATED: undefined,
  REVOKE_SUBMITTED: undefined,
  REVOKED_NOTIFIED: undefined,
  REVOKED: undefined,
  STAGED: undefined,
  TRANSLATED: undefined,
  TIMED_OUT: TIMED_OUT_TOOLTIP_MESSAGE,
  TIMED_OUT_NOTIFIED: TIMED_OUT_TOOLTIP_MESSAGE,
};

export const RequestStatusTag: React.FC<{
  status: string;
  style?: React.CSSProperties;
}> = ({ status, style }) => {
  if (!isa(RequestStatuses, status)) return "Unknown";

  const friendly = STATUS_MAPPING[status];
  const tooltip = TOOLTIP_MAPPING[status];

  return (
    <Tooltip title={tooltip}>
      <StyledTag
        color={COLOR_MAP[friendly]}
        style={{
          ...style,
          textAlign: "center",
          width: "100%",
          maxWidth: "15em",
        }}
        key={status}
        ellipsis={true}
      >
        {STATUS_MAPPING[status]}
      </StyledTag>
    </Tooltip>
  );
};
